import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Pricing from "../pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import Classes from "@/pages/Classes";
import SharedClasses from "@/pages/SharedClasses";
import SharedClass from "@/pages/SharedClass";
import { Class } from "@/pages/Class";
import Usage from "@/pages/Usage";
import Billing from "@/pages/Billing";
import RootLayout from "@/layouts/root-layout";
import DashboardLayout from "@/layouts/dashboard-layout";
import PublicLayout from "@/layouts/public-layout";
import { ReportCard } from "@/pages/ReportCard";
import NotFound from "@/pages/NotFound";
import { FreeTrialReportCardProgressV2 as ProgressPage } from "@/reports/progress-gr1-6-2023-07/Page";
import { FreeTrialReportCardProvincialV2 as ProvincialPage } from "@/reports/provincial-gr1-6-2023-09/Page";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <PublicLayout />,
        children: [
          { path: "/", element: <Home /> },
          { path: "/about", element: <About /> },
          { path: "/contact", element: <Contact /> },
          { path: "/pricing", element: <Pricing /> },
          { path: "/pgrc", element: <ProgressPage /> },
          { path: "/pvrc", element: <ProvincialPage /> },
        ],
      },
      {
        element: <DashboardLayout />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/classes", element: <Classes /> },
          { path: "/shared-classes", element: <SharedClasses /> },
          { path: "/shared-classes/:sharedClassId", element: <SharedClass /> },
          { path: "/shared-classes/:sharedClassId/reports/:id", element: <ReportCard /> },
          { path: "/classes/:reportGroupId", element: <Class /> },
          { path: "/classes/:reportGroupId/reports/:id", element: <ReportCard /> },
          { path: "/usage", element: <Usage /> },
          { path: "/billing", element: <Billing /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
